var map = {
	"./black/settings.svg": "d7f0",
	"./dance/settings.svg": "448a",
	"./melody/settings.svg": "ceca",
	"./rhythm/settings.svg": "c6ed",
	"./sing/settings.svg": "56a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ad9";